// 実施できる施策 タイトル高さ
function setEqualHeights() {
	const titles = document.querySelectorAll(".merit__measure-ttl");
	if (!titles.length) return;

	// リセット
	titles.forEach((el) => (el.style.height = ""));

	const viewport = window.innerWidth;

	if (viewport > 768) {
		// --- PC: 全て同じ高さに ---
		const maxH = Math.max(...[...titles].map((el) => el.offsetHeight));
		titles.forEach((el) => (el.style.height = `${maxH}px`));
	} else {
		// --- SP/TB: 行ごとに高さ揃え ---
		let currentTop = null;
		let rowEls = [];
		[...titles].forEach((el) => {
			const top = el.getBoundingClientRect().top;
			if (currentTop === null) currentTop = top;

			if (Math.abs(top - currentTop) > 5) {
				const rowMax = Math.max(...rowEls.map((e) => e.offsetHeight));
				rowEls.forEach((e) => (e.style.height = `${rowMax}px`));
				currentTop = top;
				rowEls = [];
			}
			rowEls.push(el);
		});
		if (rowEls.length) {
			const rowMax = Math.max(...rowEls.map((e) => e.offsetHeight));
			rowEls.forEach((e) => (e.style.height = `${rowMax}px`));
		}
	}
}

// 初回・リサイズ・画像読み込み後に実行
window.addEventListener("load", setEqualHeights);
window.addEventListener("resize", () => {
	clearTimeout(window._ttlResizeTimer);
	window._ttlResizeTimer = setTimeout(setEqualHeights, 150);
});

// お取組みの流れタイトル 高さ
function setFlowTtlHeight() {
	const titles = document.querySelectorAll(".flow__ttl");
	if (!titles.length) return;

	// リセット
	titles.forEach((el) => (el.style.height = ""));

	const viewport = window.innerWidth;
	if (viewport <= 768) return; // 768px以下は無効

	// 一番高い高さを取得
	const maxH = Math.max(...[...titles].map((el) => el.offsetHeight));
	titles.forEach((el) => (el.style.height = `${maxH}px`));
}

// ページロード時・リサイズ時に実行
window.addEventListener("load", setFlowTtlHeight);
window.addEventListener("resize", () => {
	clearTimeout(window._flowResizeTimer);
	window._flowResizeTimer = setTimeout(setFlowTtlHeight, 150);
});

// よくあるご質問 アコーディオン
document.addEventListener("DOMContentLoaded", () => {
	const faqButtons = document.querySelectorAll(".faq__heading");

	faqButtons.forEach((btn) => {
		btn.addEventListener("click", () => {
			const parentItem = btn.closest(".faq__item");
			const content = parentItem.querySelector(".faq__content");
			const isOpen = parentItem.classList.contains("is-open");

			// トグル状態更新
			parentItem.classList.toggle("is-open", !isOpen);
			btn.setAttribute("aria-expanded", String(!isOpen));
		});
	});
});

// よくあるご質問 回答幅
function setFaqAnswerWidth() {
	const faqItems = document.querySelectorAll(".faq__item");
	if (!faqItems.length) return;

	faqItems.forEach((item) => {
		const question = item.querySelector(".faq__heading .faq__question");
		const content = item.querySelector(".faq__content");
		const answer = item.querySelector(".faq__answer");
		if (!question || !content || !answer) return;

		// 質問テキストの幅を取得（px）
		const questionWidth = question.offsetWidth;

		// 横幅を同じに設定
		answer.style.width = questionWidth + "px";

		// 質問テキストの左端位置を取得
		const questionRect = question.getBoundingClientRect();
		const itemRect = item.getBoundingClientRect();
		let leftOffset = questionRect.left - itemRect.left;

		// 親(.faq__content)の左paddingを取得して差し引く
		const contentPaddingLeft = parseFloat(window.getComputedStyle(content).paddingLeft);
		if (!isNaN(contentPaddingLeft)) {
			leftOffset -= contentPaddingLeft;
		}

		// 左マージンを設定
		answer.style.marginInlineStart = leftOffset + "px";
	});
}

// 初期表示とリサイズ時に実行
window.addEventListener("load", setFaqAnswerWidth);
window.addEventListener("resize", () => {
	clearTimeout(window._faqResizeTimer);
	window._faqResizeTimer = setTimeout(setFaqAnswerWidth, 150);
});

// 追従CTA
document.addEventListener("DOMContentLoaded", () => {
	const followCta = document.querySelector(".followCta");
	const mv = document.querySelector(".mv");
	if (!followCta || !mv) return;

	const handleScroll = () => {
		const scrollY = window.scrollY || window.pageYOffset;
		const windowHeight = window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const mvHeight = mv.offsetHeight;

		const isBeyondMv = scrollY > mvHeight; // MVを超えた
		const isBottom = scrollY + windowHeight >= documentHeight - 10; // ページ最下部に到達

		if (isBeyondMv && !isBottom) {
			// MVを超えていて、かつ最下層ではないとき
			followCta.classList.add("is-show");
		} else {
			// それ以外は非表示
			followCta.classList.remove("is-show");
		}
	};

	// 初期実行 + スクロールイベント
	window.addEventListener("scroll", handleScroll);
	handleScroll();
});
